import { cn } from '../../lib/cn.js';

type Props = {
  name: string;
  size?: 'sm' | 'md';
  className?: string;
};

function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]?.charAt(0).toUpperCase() ?? '?';
  return (
    (parts[0]?.charAt(0) ?? '') + (parts[parts.length - 1]?.charAt(0) ?? '')
  ).toUpperCase();
}

const sizes = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
};

export function Avatar({ name, size = 'md', className }: Props) {
  return (
    <div
      className={cn(
        'inline-flex items-center justify-center rounded-full font-semibold tracking-tightish',
        'bg-gradient-to-br from-cream-deep to-gold/30 text-navy',
        'ring-1 ring-line',
        sizes[size],
        className,
      )}
      aria-label={name}
    >
      {initials(name)}
    </div>
  );
}
